/* unplugin-vue-components disabled */import script from "./Energy.vue?vue&type=script&setup=true&lang=ts"
export * from "./Energy.vue?vue&type=script&setup=true&lang=ts"

import "./Energy.vue?vue&type=style&index=0&id=52de9ac2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52de9ac2"]])

export default __exports__